import cn from 'classnames';
import type { FC } from 'react';
import React from 'react';

import RainbowHighlight from 'components/basic/RainbowHighlight';
import Typograf from 'components/basic/Typograf';
import { BodyL, H1 } from 'components/basic/Typography';
import NumberedItems from 'components/pagesComponents/landing/ForResearches/components/DataIn/components/NumberedItems';
import {
  imagesWithText,
  numberedItemsTexts,
} from 'components/pagesComponents/landing/ForResearches/components/DataIn/constants';
import { typeformUrl } from 'components/pagesComponents/landing/ForResearches/constants';

import s from './DataIn.module.scss';

const DataIn: FC = () => {
  const imagesWithTextEls = imagesWithText.map(el => {
    return (
      <div
        key={el.text}
        className={cn(
          s.imgTextWrapper,
          'g-col-sm-6 g-col-md-4 g-col-lg-2 g-col-xm-2',
        )}
      >
        <img
          className="mb-sm-1 mb-xl-7"
          src={`/pagesImages/landing/for-researches/datain/${el.image}`}
          alt=""
        />
        <BodyL>{el.text}</BodyL>
      </div>
    );
  });

  return (
    <Typograf>
      <RainbowHighlight
        className={cn(
          s.rainbow,
          'mt-sm-23 mt-xm-20 mt-xl-25 mb-sm-23 mb-xm-20 mb-xl-25',
        )}
        text="Data in, insights out"
        buttonText="Apply now"
        href={typeformUrl}
      />
      <H1 className={cn(s.h1, 'mb-sm-6 mb-xl-12')} Tag="h2">
        {/* @ts-ignore */}
        <a name="Eight-benefits-for-partners">
          Top eight benefits for our partners
        </a>
      </H1>
      <NumberedItems className="mb-sm-23 mb-xm-20" items={numberedItemsTexts} />

      <H1 className="text-center mb-sm-6 mb-xm-4 mb-lg-10 mb-xl-6">
        These are some ways how HRV can be used
      </H1>
      <div className="grid">{imagesWithTextEls}</div>
    </Typograf>
  );
};

export default DataIn;
